module.exports = __webpack_public_path__ + "static/media/welcome_page_coffee.5c858568.svg";